import toURL from '@homeaway/search-url-parser/dist/transpiled/toURL';
import { getKeyFromCookie } from '../../../server/data/utils/searchboxCookies';

export const buildPropertyTypeSerpUrl = ({ destination, serpFilter, cookie = '' }) => {
  const haTripPrstCookie = getKeyFromCookie(cookie, 'ha-trip-prst') || {
    arrival: '',
    departure: ''
  };

  const {
    arrival,
    departure,
    numberOfAdults,
    numberOfChildren,
    petIncluded
  } = haTripPrstCookie;

  return toURL({
    arrival,
    departure,
    filter: serpFilter,
    q: destination,
    adultsCount: numberOfAdults,
    childrenCount: numberOfChildren,
    petIncluded
  });
};
